const apiRoot = '/api/v1';

export { apiRoot };
